<template>
  <a :href="url" download="ufc-staredown-supercut.gif" @click="onClick">
    <BaseButtonCircle>
      <img src="@/assets/img/download.svg"/>
    </BaseButtonCircle>
  </a>
</template>

<script>
import BaseButtonCircle from '@/components/BaseButtonCircle/BaseButtonCircle'
export default {
  components: {
    BaseButtonCircle
  },
  props: {
    url: {
      type: String,
      required: true
    }
  },
  methods: {
    onClick (e) {
      this.$ga.event('share', 'download')
      if (!('download' in document.createElement('a'))) {
        e.preventDefault()
        window.open(this.url, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  height: 40%;
  width: auto;
  display: block;
}
</style>
